





















import Vue from "vue";
import Content from "../../../dex-shared/components/content/Content.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "InteractiveDataResults",
  components: {
    Content,
    CheckIcon,
    CloseIcon
  },
  props: ["interactiveData", "question"],
  computed: {
    ...mapGetters({
      reply: "sessionQuestionReply"
    }),
    sessionReply(): any {
      if (!this.question) return null;
      const r = (this as any).reply(this.question.id);
      return r || null;
    },
    alternatives(): any[] {
      const data = this.interactiveData;
      return (data && data.alternatives) || [];
    },
    alternativeState(): Record<string, boolean>[] {
      const r = this.sessionReply;
      return this.alternatives.map((_alternative: any, index: number) => {
        if (!r) return {};
        
        const isUserPick = +r.answer === +index;
        const isCorrectOption = +r.correctAnswer === +index;

        return {
          checked: isUserPick,
          correct: isCorrectOption,
          wrong: isUserPick && !isCorrectOption,
          unchecked: !isUserPick && !isCorrectOption
        };
      });
    }
  }
});
